/**
 * WebSocket Event Types
 *
 * Connection and subscription events for socket management.
 * Domain events (tasks, meetings, conversations, etc.) use CloudEvents format
 * defined in src/types/cloud-events.ts
 */

// Re-export CloudEvents types for convenience
export {
  CloudEventType,
  DELIVERABLE_STATUS_UPDATED_SOCKET_EVENT,
  isDeliverableStatusUpdatedType,
  type CloudEvent,
  type CloudEventTypeValue,
  type ChannelName,
  type DeliverableStatusUpdatedData,
  type DeliverableStatusUpdatedEvent,
  getEntityIdFromCloudEvent,
  getChannelFromCloudEventType,
} from '@/types/cloud-events';

/**
 * WebSocket connection and subscription events
 * These are protocol-level events, not domain events
 */
export enum WebSocketEventType {
  // Connection events
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  PING = 'ping',
  PONG = 'pong',

  // Subscription events
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
}
